import { ACCESS_GROUPS, hasAccessGroup } from "../../access-control/models/access-groups.models";
import { ADMIN_PATHS } from "../../admin/models/admin.models";
import { useAuthContext } from "../../auth/state/AuthContext";
import AdminFlowsWorkspace from "../components/flows/AdminFlowsWorkspace";
import { useAdminAgentSessionScope } from "../hooks/useAdminAgentSessionScope";
import { getAdminAgentBrowserTokenScope } from "../utils/admin-agent.utils";
import { ADMIN_FLOW_VIEWS } from "../utils/admin-flows.constants";
import { Navigate, useNavigate, useParams } from "react-router-dom";

// Replace all temporary drafts before a different identity or permission scope can render this workspace.
// The admin route gate is reinforced here because delegated admin features do not grant AI access.
const AdminFlowsPage = () => {
  const user = useAuthContext().state.user;
  const sessionScope = useAdminAgentSessionScope();
  const { flowView } = useParams();
  const navigate = useNavigate();
  const view = ADMIN_FLOW_VIEWS.find((entry) => entry.id === flowView)?.id;
  let renderedScope: string | undefined;

  try {
    renderedScope = user?.accessTokenRaw ? getAdminAgentBrowserTokenScope(user.accessTokenRaw) : undefined;
  } catch {
    renderedScope = undefined;
  }

  if (
    !hasAccessGroup(user?.accessToken?.groups, ACCESS_GROUPS.Admin) ||
    !sessionScope ||
    sessionScope !== renderedScope
  )
    return null;

  const scope = JSON.stringify([sessionScope, [...(user?.accessControl?.grantedFeatures ?? [])].sort()]);

  if (!view) return <Navigate to={`${ADMIN_PATHS.aiFlows}/whiteboard`} replace />;

  return (
    <AdminFlowsWorkspace key={scope} view={view} onSelectView={(next) => navigate(`${ADMIN_PATHS.aiFlows}/${next}`)} />
  );
};

export default AdminFlowsPage;
